import React, { ForwardedRef, forwardRef, memo, useMemo } from 'react'
import useStyles from './styles'

export interface ITagsProps extends React.HTMLProps<HTMLSpanElement> {
  separator?: 'default' | 'pipe'
  dense?: boolean
}

function Tags(props: ITagsProps, ref: ForwardedRef<HTMLSpanElement>) {
  const { classes } = useStyles()
  const { separator, children, className, dense, ...restProps } = props

  const baseClassName = useMemo(() => {
    let classList = [] as string[]

    if (separator === 'pipe') {
      classList.push(classes.tagspipe)
    } else {
      classList.push(classes.tags)
    }

    if (dense) {
      classList.push(classes.dense)
    }

    if (className) {
      classList.push(className)
    }

    return classList.join(' ')
  }, [separator, dense, className])

  return (
    <span ref={ref} {...restProps} className={baseClassName}>
      {children}
    </span>
  )
}

export default memo(forwardRef(Tags))
